"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIMatchTextArea = _interopRequireDefault(require("UIComponents/input/UIMatchTextArea"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    margin-left: 0;\n    margin-bottom: 16px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    margin-bottom: 8px;\n    margin-top: 8px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUIAlert = (0, _styledComponents.default)(_UIAlert.default).withConfig({
  displayName: "DeleteDialog__StyledUIAlert",
  componentId: "m4vmli-0"
})(_templateObject());
var StyledGdprNoteUIAlert = (0, _styledComponents.default)(_UIAlert.default).withConfig({
  displayName: "DeleteDialog__StyledGdprNoteUIAlert",
  componentId: "m4vmli-1"
})(_templateObject2());

var DeleteDialog =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DeleteDialog, _PureComponent);

  function DeleteDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DeleteDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeleteDialog).call(this, props));
    _this.state = {
      gdprDelete: false,
      matched: props.match === '',
      applyToAll: false
    };
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DeleteDialog, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var value = _ref.target.value;
      this.setState({
        gdprDelete: value === 'gdpr-delete'
      });
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      this.props.onConfirm(this.state);
    }
  }, {
    key: "handleMatch",
    value: function handleMatch(_ref2) {
      var value = _ref2.target.value;
      this.setState({
        matched: value
      });
    }
  }, {
    key: "getGdprNote",
    value: function getGdprNote() {
      var gdprNote = this.props.gdprNote;
      return gdprNote && _react.default.createElement(StyledUIAlert, {
        type: "tip"
      }, gdprNote);
    }
  }, {
    key: "renderDialogBody",
    value: function renderDialogBody() {
      var _this$props = this.props,
          dialogBody = _this$props.dialogBody,
          match = _this$props.match;
      var marginClass = match ? 'm-bottom-0' : 'm-bottom-4';

      if (!dialogBody) {
        return null;
      }

      return _react.default.createElement("div", {
        className: marginClass
      }, dialogBody);
    }
  }, {
    key: "renderApplyToAll",
    value: function renderApplyToAll() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasNoFilters = _this$props2.hasNoFilters,
          objectType = _this$props2.objectType;
      var applyToAll = this.state.applyToAll;

      if (!hasNoFilters) {
        return null;
      }

      return _react.default.createElement(_UIFormControl.default, {
        required: true
      }, _react.default.createElement(_UICheckbox.default, {
        id: "apply-to-all-checkbox",
        checked: applyToAll,
        onChange: function onChange(_ref3) {
          var checked = _ref3.target.checked;

          _this2.setState({
            applyToAll: checked
          });
        },
        className: "m-bottom-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataUiUtilities.DeleteDialog.confirmApplyToAll." + objectType
      })));
    }
  }, {
    key: "renderMatch",
    value: function renderMatch() {
      var _this$props3 = this.props,
          match = _this$props3.match,
          matchLabel = _this$props3.matchLabel;

      if (!match) {
        return null;
      }

      return _react.default.createElement(_UIFormControl.default, {
        className: "m-bottom-4 m-left-0",
        label: matchLabel
      }, _react.default.createElement(_UIMatchTextArea.default, {
        match: match,
        onMatchedChange: this.handleMatch,
        size: "xxl"
      }));
    }
  }, {
    key: "renderNote",
    value: function renderNote() {
      var dialogNote = this.props.dialogNote;

      if (!dialogNote) {
        return null;
      }

      return _react.default.createElement(StyledGdprNoteUIAlert, {
        type: "tip"
      }, dialogNote);
    }
  }, {
    key: "renderGdprRadioSelect",
    value: function renderGdprRadioSelect() {
      var gdprDelete = this.state.gdprDelete;
      var _this$props4 = this.props,
          gdprEnabled = _this$props4.gdprEnabled,
          gdprDeletePossible = _this$props4.gdprDeletePossible,
          isScopedForGdprDelete = _this$props4.isScopedForGdprDelete;

      if (!gdprEnabled || !gdprDeletePossible) {
        return null;
      }

      var gdprNoteElement = this.getGdprNote();
      return _react.default.createElement(_UIList.default, {
        className: "m-left-0",
        childClassName: "m-bottom-4"
      }, _react.default.createElement(_UIRadioInput.default, {
        id: "normal-delete-radio-input",
        name: "normal",
        value: "normal-delete",
        checked: !gdprDelete,
        onChange: this.handleChange
      }, _react.default.createElement(_FormattedJSXMessage.default, {
        message: "crm_components.GDPRDeleteDialog.normalDeleteLabel_jsx",
        elements: {
          Link: _UILink.default
        }
      })), _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "crm_components.GDPRDeleteDialog.permissions.cantDelete"
        }),
        disabled: isScopedForGdprDelete
      }, _react.default.createElement(_UIRadioInput.default, {
        id: "gdpr-delete-radio-input",
        name: "gdpr",
        disabled: !isScopedForGdprDelete,
        value: "gdpr-delete",
        checked: gdprDelete,
        onChange: this.handleChange
      }, _react.default.createElement(_FormattedJSXMessage.default, {
        message: "crm_components.GDPRDeleteDialog.gdprDeleteLabel_jsx",
        elements: {
          Link: _UILink.default
        }
      }), gdprDelete && gdprNoteElement)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          confirmLabel = _this$props5.confirmLabel,
          hasNoFilters = _this$props5.hasNoFilters,
          message = _this$props5.message,
          onReject = _this$props5.onReject,
          rejectLabel = _this$props5.rejectLabel,
          title = _this$props5.title;
      var _this$state = this.state,
          applyToAll = _this$state.applyToAll,
          matched = _this$state.matched;
      var isApplyToAllGuardSatisfied = hasNoFilters ? applyToAll : true;
      var titleStyle = message ? 'is--heading-4' : 'is--heading-4 m-bottom-0';
      return _react.default.createElement(_UIModal.default, {
        use: "danger"
      }, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onReject
      }), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement("h4", {
        className: titleStyle
      }, _react.default.createElement(_UITruncateString.default, null, title)), message), _react.default.createElement(_UIDialogFooter.default, {
        layout: "legacy",
        className: "p-top-4"
      }, this.renderDialogBody(), this.renderMatch(), this.renderApplyToAll(), this.renderGdprRadioSelect(), this.renderNote(), _react.default.createElement(_UIButton.default, {
        className: "m-left-0",
        "data-selenium-test": "delete-dialog-confirm-button",
        "data-confirm-button": "accept",
        onClick: this.handleConfirm,
        use: "danger",
        disabled: !matched || !isApplyToAllGuardSatisfied
      }, confirmLabel), _react.default.createElement(_UIButton.default, {
        onClick: onReject,
        use: "tertiary-light"
      }, rejectLabel)));
    }
  }]);
  return DeleteDialog;
}(_react.PureComponent);

var propTypes = (0, _extends2.default)({
  confirmLabel: _react.PropTypes.node.isRequired,
  gdprDeletePossible: _react.PropTypes.bool.isRequired,
  gdprEnabled: _react.PropTypes.bool.isRequired,
  gdprNote: _react.PropTypes.element,
  isScopedForGdprDelete: _react.PropTypes.bool.isRequired,
  match: _react.PropTypes.string,
  message: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.element.isRequired]),
  onConfirm: _react.PropTypes.func.isRequired,
  onReject: _react.PropTypes.func.isRequired,
  rejectLabel: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element.isRequired]),
  title: _react.PropTypes.node.isRequired
}, _PromptablePropInterface.default);
var defaultProps = {
  dialogBody: null,
  gdprDeletePossible: false,
  gdprEnabled: false,
  hasNoFilters: false,
  isScopedForGdprDelete: false,
  match: '',
  rejectLabel: _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "customerDataUiUtilities.DeleteDialog.rejectLabel"
  })
};
DeleteDialog.propTypes = propTypes;
DeleteDialog.defaultProps = defaultProps;
var _default = DeleteDialog;
exports.default = _default;
module.exports = exports.default;